import { render } from "./property-popphotosingle.vue?vue&type=template&id=4822dd05"
import script from "./property-popphotosingle.js?vue&type=script&lang=js"
export * from "./property-popphotosingle.js?vue&type=script&lang=js"

import "./property-popphotosingle.vue?vue&type=style&index=0&id=4822dd05&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__